export default __webpack_public_path__ + "static/media/16.b32e29f6.png";